import { render, staticRenderFns } from "./SubscribeToTicketNotifications.vue?vue&type=template&id=072a3372&"
import script from "./SubscribeToTicketNotifications.vue?vue&type=script&lang=ts&"
export * from "./SubscribeToTicketNotifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072a3372')) {
      api.createRecord('072a3372', component.options)
    } else {
      api.reload('072a3372', component.options)
    }
    module.hot.accept("./SubscribeToTicketNotifications.vue?vue&type=template&id=072a3372&", function () {
      api.rerender('072a3372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SubscribeToTicketNotifications.vue"
export default component.exports